






















import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class SubmissionFormStatementsItem extends Vue {
  @Prop() private id!: string;
  @Emit()
  checkedChange(e: Event) {
    return e.target as HTMLInputElement;
  }
  public checked = true;
}
